import Favicon from '../images/favicon.png';
export default Favicon;